module.exports = __webpack_public_path__ + "static/media/pdf.6fb947f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/pdf.svg
// module id = 971
// module chunks = 0